import { ReactNode } from 'react'
import { match } from 'ts-pattern'
import {
  IconCheckCircle,
  IconCircleX,
  GreenGreen70,
  RedRed70
} from '@sequencehq/core-components'

export const getManualTaskStatusIcon = (
  status: string | undefined,
  // The recorded completion outcome, when the task type distinguishes them. A
  // task can complete without being "approved" — a dismissed review still lands
  // as COMPLETED — so a 'DISMISSED' outcome shows the negative (X) icon rather
  // than the success check.
  outcome?: string
): ReactNode => {
  if (!status) return null

  const wasDismissed = outcome === 'DISMISSED'

  return match(status)
    .with('PENDING', () => null)
    .with('COMPLETED', () =>
      wasDismissed ? (
        <IconCircleX
          color={RedRed70}
          data-testid="watchtower.taskStatusIcon.dismissed"
        />
      ) : (
        <IconCheckCircle
          color={GreenGreen70}
          data-testid="watchtower.taskStatusIcon.completed"
        />
      )
    )
    .with('CANCELLED', () => (
      <IconCircleX
        color={RedRed70}
        data-testid="watchtower.taskStatusIcon.cancelled"
      />
    ))
    .otherwise(() => null)
}
